import React, { Component } from 'react';
import api from "./../../../../services/api";
import './style.css';
import { NavLink } from 'react-router-dom';
import GetNumeric from './GetName';

//import da API
import { professional } from './../../../../services/api';
let apiProfessional = new professional();

var token = localStorage.getItem('user_token');
var medico_id = localStorage.getItem('professional_id');



//Classe para API
export default class DataExam extends Component {
  state = {
    exames: [],
  }

  componentDidMount() {
    this.loadData();
  }

  loadData = async () => {
    //const request = await api.get(`/exam/professional/${medico_id}?status=Realizada`, {headers: {'x-access-token': token}});
    const request = await apiProfessional.getAllProfessionalExams(medico_id, [{ header: 'status', value: 'Realizada' }]);
    console.log(request);
    console.log(request.data);
    this.setState({ exames: request.data });

  };

  render() {
    return (
      <>
        <div id="lista-style">

          {this.state.exames.map(exam => (
            <>
              <NavLink to={{ pathname: '/tela_ps_cpa/' + exam._id }}>
                <button id="option-PS-Painel" key={exam._id}><GetNumeric user_id={exam.user_id} /></button>
              </NavLink>
            </>
          ))}
        </div>
      </>

    );
  }

}
